import { Phone, PhoneOff } from "lucide-react";

type Props = {
  connected: boolean;
  className?: string;
};

/** Green handset when connected; red crossed handset when not (same in all WhatsApp settings cards). */
export function WhatsappNumberConnectionIcon({
  connected,
  className = "",
}: Props) {
  const base = `w-5 h-5 shrink-0 ${className}`.trim();
  if (connected) {
    return (
      <Phone
        className={`${base} text-emerald-600`}
        strokeWidth={2}
        aria-hidden
      />
    );
  }
  return (
    <PhoneOff
      className={`${base} text-red-600`}
      strokeWidth={2}
      aria-hidden
    />
  );
}
